import { render, staticRenderFns } from "./YesNoTask.vue?vue&type=template&id=127d2c69"
import script from "./YesNoTask.vue?vue&type=script&lang=ts"
export * from "./YesNoTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports